<template src="./templates/not-found.html"></template>
<script>

export default {
    name: 'NotFound',

};
</script>
